import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppUser } from 'Model';
import { UtilserviceService } from 'app/services/utilservice.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, OnDestroy {
  style: any;
  user: AppUser;
  registrationForm: FormGroup;
  loading= false;
  logo: string;
  constructor(private fb: FormBuilder, private util: UtilserviceService, private route: Router) { }
  
  ngOnInit(): void {
    this.style = this.util.getDomainEnviroment().style;
    this.user = new AppUser();
    window.addEventListener('message', this.receiveCredMessage.bind(this), false);
    this.registrationForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      fname: ['', [Validators.required]],
      lname: ['', [Validators.required]],
      phone:["", [Validators.required, Validators.pattern("^[0-9_-]{11}")]],
      passwordII: ["", [Validators.required]],
    },
    {      
      validators: this.util.passwordMatchValidator
    });
    this.logo = this.util.getDomainEnviroment().landingPageLogo;
  }
  get email() {
    return this.registrationForm.get('email');
  }
  get fname() {
    return this.registrationForm.get('fname');
  }
  get lname() {
    return this.registrationForm.get('lname');
  }
  get phone() {
    return this.registrationForm.get('phone');
  }
  async receiveCredMessage(event: MessageEvent){
    await this.util.receiveGoogleAuthToken(event);
  }

  async register(){
    if (this.registrationForm.valid) {
      try {
        this.loading = true
        const formValue = this.registrationForm.value;
        this.user.Email = formValue.email;
        this.user.Fname = formValue.fname;
        this.user.Lname = formValue.lname;
        this.user.Password = formValue.password;
        this.user.Phone = formValue.phone;
        this.user.Domain = '';
        let jwtUser =await this.util.register(this.user);      
        if(jwtUser.token){
          this.util.setAuthenticatedUserToken(jwtUser);
          this.route.navigateByUrl("/dashboard");
        }
      } catch (error) {
        this.loading= false;
        console.log(error);
        
      }finally {
        this.loading= false;
      }
     
    }
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.receiveCredMessage);
  }
}
